import { StyledMessageBox } from './style';
export interface IMessageBoxProps {
  title: string;
  text: string;
  fontFamily: string;
  borderColor: string;
  logo: string;
}

export const MessageBox: React.FC<IMessageBoxProps> = ({
  title,
  text,
  fontFamily,
  borderColor,
  logo,
}) => (
  <StyledMessageBox fontFamily={fontFamily} borderColor={borderColor}>
    <img className="message_box_logo" src={logo} alt="logo" />
    <h2 className="message_box_title">{title}</h2>
    <p className="message_box_text">{text}</p>
  </StyledMessageBox>
);
